import type { iCustomerPaymentReceipt } from "@sdk/bookings/booking-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectCustomerPaymentReceiptQueryMap,
  selectEntityMap: selectCustomerPaymentReceiptsMap,
  selectQueryMapAll: selectCustomerPaymentReceiptsMapAll,
  selectQueryAllList: selectCustomerPaymentReceiptsAllList,
  selectAllEntities: selectAllCustomerPaymentReceipts,
  selectAllEntitiesQuery: selectAllCustomerPaymentReceiptsQuery,
  selectEntityById: selectCustomerPaymentReceiptById,
  selectEntityQuery: selectCustomerPaymentReceiptQuery,
  selectEntityQueryList: selectCustomerPaymentReceiptQueryList,
} = CreateSelectorForEntities<iStore, iCustomerPaymentReceipt>({
  sliceName: "customerPaymentReceipts",
});
